import React, { ComponentProps } from 'react';

import styledC from 'styled-components';

import Avatar from '@adsk/alloy-react-avatar';
import {
  isGroupHeader,
  RenderMenuItem,
  VirtualizedMenuGroupHeader,
  VirtualizedMenuItem,
} from '@adsk/alloy-react-dropdown';
import {
  BuildingIcon,
  PeopleIcon,
  RenderIconType,
} from '@adsk/alloy-react-icon';
import Theme from '@adsk/alloy-react-theme';
import { OverflowTooltip } from '@adsk/alloy-react-tooltip';

import { ASSIGNEE_PICKER_COMPANY, ASSIGNEE_PICKER_ROLE } from '../consts';
import { ItemWithGroup } from '../types';

const AssigneePickerVirtualizedMenuItem = styledC(VirtualizedMenuItem)`
  align-items: center;
`;

export const AssigneePickerMenuItem: RenderMenuItem<ItemWithGroup> = (
  itemProps,
) => {
  if (isGroupHeader(itemProps)) {
    return (
      <VirtualizedMenuGroupHeader {...itemProps}>
        {itemProps.label}
      </VirtualizedMenuGroupHeader>
    );
  }

  let renderFallbackIcon: RenderIconType | null = null;

  if (itemProps.item.group === ASSIGNEE_PICKER_COMPANY) {
    renderFallbackIcon = BuildingIcon.renderIcon;
  }

  if (itemProps.item.group === ASSIGNEE_PICKER_ROLE) {
    renderFallbackIcon = PeopleIcon.renderIcon;
  }

  const isMember =
    itemProps.item.group !== ASSIGNEE_PICKER_COMPANY &&
    itemProps.item.group !== ASSIGNEE_PICKER_ROLE;

  const iconProps: Partial<ComponentProps<typeof VirtualizedMenuItem>> = {
    renderLeftComponent: () => (
      <Avatar
        image={itemProps.item.imageUrl}
        size={Avatar.SIZES.MEDIUM_32}
        name={itemProps.item.label as string}
        style={{
          marginRight: Theme.spacing.XS,
          ...(!isMember ? { backgroundColor: Theme.colors.charcoal100 } : {}),
        }}
      >
        {renderFallbackIcon?.({ size: Theme.spacing.M })}
      </Avatar>
    ),
  };

  const { subtext } = itemProps.item;
  if (typeof subtext !== 'string') {
    return <AssigneePickerVirtualizedMenuItem {...iconProps} {...itemProps} />;
  }

  return (
    <AssigneePickerVirtualizedMenuItem
      {...iconProps}
      {...itemProps}
      subtext={
        <OverflowTooltip
          content={subtext}
          placement={OverflowTooltip.PLACEMENTS.TOP}
          data-testid="AssigneePicker--subtextTooltip"
        >
          {subtext}
        </OverflowTooltip>
      }
    />
  );
};
